<template>
  <div>
    <register-title class="form__title">{{
      $t("management structure")
    }}</register-title>
    <br />
    <div class="row">
      <div
        class="col-xs-12"
        v-for="(body, body_index) in controlBodies"
        :key="`${body_index}-control-body`"
      >
        <div class="rep_minimize" style="margin-top:0px; padding: 15px;">
          <div v-if="body.data">
            <div class="row">
              <div class="col-xs-12">
                <h1>"{{ body.data.name }}"</h1>
                <p style="font-size: 20px;font-style: italic">
                  {{ body.title }}
                  <!--                  <span style="color: #767d8a"-->
                  <!--                    >сост. {{ typeof body.data.members }}-->
                  <!--                  </span>-->
                </p>
                <br />
              </div>
            </div>
            <div class="row bottom-xs">
              <div class="col-xs ">
                <span style="color: #767d8a" @click="deleteControlBody(body)">
                  {{ $t("delete") }}
                </span>
              </div>
              <div class="col-xs-8 end-xs">
                <router-link
                  tag="span"
                  :to="{
                    name: 'legal-control-form-detail',
                    params: { body_type: body.type, control_id: body.data.id }
                  }"
                  style="color: #1a75e9"
                >
                  {{ $t("add") }} {{ $t("info").toLowerCase() }}
                </router-link>
              </div>
            </div>
          </div>
          <div v-else>
            <h1>
              {{ body.title }}
            </h1>
            <register-input
              v-model="body.name"
              componentID="series"
              inputType="text"
              :label="$t('managing organ name')"
              :inputPlaceholder="$t('managing organ name')"
              :isRequired="false"
              class="form__input"
            />
            <button
              @click="initControlBody(body.name, body.type)"
              class="button sm filled form__button text-right"
              v-if="body.name"
            >
              {{ $t("create") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <file-input
      :mini="true"
      :is_uploaded="form_files.control_member_id"
      v-model="form_files.control_member_id"
      @attached="saveFile(form_files.control_member_id, 'control_member_id')"
      class="form__input-container"
      componentID="doc_1"
    >
      {{ $t("executive body id") }}
    </file-input>
    <div class="col-xs-12">
      <button class="button form__button" @click="nextStep">
        {{ $t("continue") }}
      </button>
    </div>
  </div>
</template>
<style scoped>
.progress {
  min-width: 0%;
  border: 2px solid #1a75e9;
  border-radius: 3px;
  margin-bottom: 5px;
}
.form__input input {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: white;
}
.form__input {
  margin-bottom: 10px;
}
.button.sm {
  margin: 0 !important;
  width: auto;
  display: block !important;
  padding: 9px;
}
</style>
<script>
import regFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";
import ControlFormMixin from "../cotnrol_form_mixin";
export default {
  props: ["user_profile"],
  name: "MainRegForm",
  data() {
    return {
      form_list: [],
      form_files: {
        control_member_id: null
      }
    };
  },
  mixins: [regFormMixin, ControlFormMixin],
  computed: {},
  methods: {
    initControlBody(name, type) {
      FhsAxios.post("profile/user-control", {
        name: name,
        type: type
      }).then(res => {
        if (res.data.status) {
          this.$toasted.success(this.$t("new governing body"));
          this.fetchForm();
          this.$router.push({
            name: "legal-control-form-detail",
            params: {
              body_type: type,
              control_id: res.data.result.id
            }
          });
          return;
        }
        this.$toasted.error(this.$t("error save"));
      });
    },
    deleteControlBody(data) {
      this.$toasted.show(this.$t("loading"));
      try {
        data.need_to_delete.forEach(function(deletable) {
          FhsAxios.post(`profile/user-control/${deletable.id}/delete`);
        });
        this.$toasted.clear();
        this.$toasted.show(this.$t(this.$t("deleted")));
        setTimeout(() => {
          this.fetchForm();
          data.data = null;
          data.name = "";
        }, 1500);
      } catch (e) {
        this.$toasted.show(this.$t("delete error"));
      }
    },
    fetchForm() {
      try {
        FhsAxios.get("profile/user-controls").then(res => {
          if (res.data.status) {
            this.form_list = res.data.result;
          }
          Object.entries(this.form_files).map(obj => {
            let find_file = this.user_profile.userUploadedDocuments.find(
              file => file.type === obj[0]
            );
            this.form_files[obj[0]] = (find_file ? true : null) || null;
          });
        });
        // console.log(this.user_profile);
      } catch (e) {
        console.log(e);
        // ERROR HANDLER
      }
    },
    nextStep() {
      if (this.form_files.control_member_id) {
        this.$router.push({ name: "representatives-info-list" });
      } else {
        this.$toasted.show(this.$t("attach file"));
      }
    }
  },
  beforeMount() {
    this.fetchForm();
  }
};
</script>
